/**
 * Created by jonas on 2021-02-09.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TrueGritStatics} from "../../TrueGritStatics";
import {TrueGritReelModel} from "../../reels/TrueGritReelModel";
import {TrueGrit} from "../../TrueGrit";
import {TrueGritTopReelModel} from "../../reels/TrueGritTopReelModel";
import {TrueGritMainReelView} from "./TrueGritMainReelView";
import {TrueGritBottomReelModel} from "../../reels/TrueGritBottomReelModel";
import {TrueGritGameMode} from "../../server/TrueGritGameMode";
import {gsap} from "gsap";
import {ISymbol} from "../../../core/reel/ReelInterfaces";

export class TrueGritMainAllReelsView extends PIXI.Container implements StageLayer {

    private _mainReelModels:TrueGritReelModel[];
    private _topReelModel:TrueGritTopReelModel;
    private _bottomReelModel:TrueGritBottomReelModel;

    constructor() {
        super();
        this.init();
    }

    public reInit(){
        for (let i:number = 0; i < this._mainReelModels.length; i++){
            const reel = this._mainReelModels[i];
            reel.clear();
            reel.init(TrueGrit.model.data.reels[i],false);
        }

        this._topReelModel.clear();
        this._topReelModel.init(TrueGrit.model.data.topTrain.symbols,false);

        this._bottomReelModel.clear();
        this._bottomReelModel.init(TrueGrit.model.data.botTrain.symbols,false);

    }

    private init() {
        this.name = "TrueGritMainAllReelsView";

        this._topReelModel = new TrueGritTopReelModel();
        let initSyms:string[] = [];
        const isAvalancheRestore:boolean = TrueGrit.model.isRestore == true && (TrueGrit.model.data.nextMode == TrueGritGameMode.NORMAL_AVALANCHE || TrueGrit.model.data.nextMode == TrueGritGameMode.FREESPIN_AVALANCHE
            || TrueGrit.model.data.nextMode == TrueGritGameMode.FREESPIN_SUPER_AVALANCHE);

        for(let i:number = 0; i < TrueGrit.model.data.topTrain.symbols.length; i++) {
            initSyms.push(TrueGrit.model.data.topTrain.symbols[i]);
        }
        this._topReelModel.init(initSyms, isAvalancheRestore);

        this._bottomReelModel = new TrueGritBottomReelModel();
        initSyms = [];
        if(isAvalancheRestore == true) {
            for(let i:number = 0; i < 3; i++) {
                initSyms.push(TrueGrit.model.initData.botTrain.symbolsAfterCollapse[i]);
            }
        } else {
            for(let i:number = 0; i < 3; i++) {
                initSyms.push(TrueGrit.model.data.botTrain.symbols[i]);
            }
        }
        this._bottomReelModel.init(initSyms, isAvalancheRestore);

        this._mainReelModels = [];
        let tempReel:string[];
        for(let i:number = 0; i < TrueGritStatics.defaultGameAreaSize.length; i++) {
            tempReel = [];
            const reelModel:TrueGritReelModel = new TrueGritReelModel(i)
            this._mainReelModels.push(reelModel);
            this.addChild(<TrueGritMainReelView>reelModel.reelView);
            if(isAvalancheRestore == true) {
                for(let j:number = 0; j < 5; j++) {
                    tempReel.push(TrueGrit.model.initData.reelsAfterCollapse[i][j]);
                }
            } else {
                for(let j:number = 0; j < 5; j++) {
                    tempReel.push(TrueGrit.model.data.reels[i][j]);
                }
            }

            reelModel.init(tempReel, isAvalancheRestore);
        }

        const topReelMask:PIXI.Graphics = new PIXI.Graphics();
        topReelMask.name = "topReelMask";
        topReelMask.beginFill();
        topReelMask.drawRect(0, 0, TrueGritStatics.symbolWidth * 3, TrueGritStatics.symbolHeight - 10);
        topReelMask.position = TrueGritStatics.TOP_REEL_VIEW_MASK_POSITION;
        this._topReelModel.reelView.addChild(topReelMask);
        this.topReelModel.reelView.mask = topReelMask;

        const bottomReelMask:PIXI.Graphics = new PIXI.Graphics();
        bottomReelMask.name = "bottomReelMask";
        bottomReelMask.beginFill();
        bottomReelMask.drawRect(0, -TrueGritStatics.symbolHeight * 3, TrueGritStatics.symbolWidth * 3, TrueGritStatics.symbolHeight * 4);
        bottomReelMask.drawRect(-TrueGritStatics.symbolWidth, -TrueGritStatics.symbolHeight * 3, TrueGritStatics.symbolWidth, TrueGritStatics.symbolHeight * 3); //Expands mask to include reel 1 the top 3 normal positions. to not  cut off nudge symbol fire.
        bottomReelMask.position = TrueGritStatics.BOTTOM_REEL_VIEW_MASK_POSITION;
        this._bottomReelModel.reelView.addChild(bottomReelMask);
        this.bottomReelModel.reelView.mask = bottomReelMask;

        const mainReelsMask:PIXI.Graphics = new PIXI.Graphics();
        mainReelsMask.name = "mainReelsMask";
        mainReelsMask.beginFill();
        mainReelsMask.drawRect(0, -2, this.getReelAreaWidth(), (this.getReelAreaHeight() - (TrueGritStatics.symbolHeight + 2)));
        mainReelsMask.drawRect(0, 0, 8 + (TrueGritStatics.symbolWidth * 2), this.getReelAreaHeight() + 6);
        mainReelsMask.position = TrueGritStatics.MAIN_REELS_VIEW_MASK_POSITION;
        this.addChild(mainReelsMask);
        this.mask = mainReelsMask;

        this.onResize();
    }


    private getReelAreaHeight():number {
        return TrueGritStatics.symbolHeight * 4;
    }

    private getReelAreaWidth():number {
        return (TrueGritStatics.symbolWidth * 6) + 20;
    }

    onResize():void {
        this.position = TrueGritStatics.MAIN_REELS_VIEW_POSITION;
        if(!NolimitApplication.isLandscape) {
            this.position.y = this.position.y - (TrueGritStatics.PORTRAIT_Y_OFFSET + NolimitApplication.screenBounds.top) / 2;
        }
    }


    public getLandingShake(reverse:boolean, reelId:number, distanceSensitive:boolean = false):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        const target = reverse ? -10 : 10;
        for(let i:number = 0; i < this.mainReelModels.length; i++) {
            const model = this.mainReelModels[i];
            const view = model.reelView;
            let distMultiplier = 1;
            if(distanceSensitive) {
                const distance = Math.abs(i - reelId) + 1;
                distMultiplier = 1 / distance;
            }

            tl.add(gsap.to(view.position, {
                duration : 0.1,
                y : target * distMultiplier,
                ease : TrueGritStatics.reelLandingShake
            }), 0);

        }
        return tl;
    }


    public getSymbolsAtPositions(reelPositions:[number, number][]):ISymbol[] {
        const result:ISymbol[] = [];
        for(let position of reelPositions) {

            if(position[0] >= 2 && position[1] == 4) {
                //The position is on bot-reel.
                result.push(TrueGrit.bottomReelView.getSymbolBySymbolPosition(position[0] - 1)); //Reel - 1
            } else {
                result.push(this.getSymbolAtPosition(position[0], position[1]));
            }
        }
        return result;
    }

    public getSymbolAtPosition(reel:number, position:number):ISymbol {
        return this.mainReelModels[reel].getSymbol(position);
    }


    public getAllVisibleSymbols():ISymbol[] {
        let result:ISymbol[] = [];
        for (let reel of this.mainReelModels){
            result = result.concat(reel.getAllSymbols());
        }

        result = result.concat(this.bottomReelModel.getAllSymbols());

        result = result.concat(this.topReelModel.getAllSymbols());

        return result;
    }

    get mainReelModels():TrueGritReelModel[] {
        return this._mainReelModels;
    }

    get topReelModel():TrueGritTopReelModel {
        return this._topReelModel;
    }

    get bottomReelModel():TrueGritBottomReelModel {
        return this._bottomReelModel;
    }
}
